import React, { useEffect, useRef, useState, useCallback } from 'react';
import { MdEast, MdOutlineHome, MdPhone } from 'react-icons/md';
import {
  CircularProgress,
  Typography,
  Snackbar,
  Alert,
  Fab,
} from '@mui/material';
import axios from 'axios';
import {
  Container,
  SearchBox,
  CustomTextField,
  SearchButton,
  ErrorAlert,
  ResultsBox,
  SearchPaperInitial,
  ChatbotMessageBubbleContainer,
  ResponseCardChatbot,
  Chatbot,
  Content,
  SearchContainer,
  SuggestionsContainer,
  TextFieldContainer,
  SearchBoxInitial,
  EndButton,
  SearchEndContainer,
  primaryColor,
  SuggestionsDropdown,
  SuggestionItem,
  // KeyboardIcon,
  LogoImage,
  GradientTitle,
  DisclaimerText,
  SuggestionChip,
  WayfindingContainer,
  LevelSwitchContainer,
  BackgroundBlur,
  // MapChip,
  LevelMapButtons,
  Three60Container,
  SuggestionsWrapper,
  LevelContainer,
  RoomsWrapper,
  ShortcutLabelInternal,
  RoomChip,
  GifContainer,
} from './FAQSearch.style';
import { LOCATION_MAP,
        resolveServiceRoute,
        centralLibraryTourData,
        musicLibraryTourData,
        hsslTourData,
        wbscTourData,
        lawLibraryTourData,
        mslTourData,
      } from '../../config';
import 'react-simple-keyboard/build/css/index.css';
import MapRenderer from '../wayfinding/MapRenderer';
import { getAvailableLevels, DEFAULT_LIBRARY } from '../wayfinding/mapConfig';
import ShortcutPanel from './ShortcutPanel';
import { useMediaQuery, useTheme } from "@mui/material";
import { RandomGifPlayer } from '../libbie/gifPlayer';
import VoiceButton from '../voice/voiceButton';
// import { RenderKeyboard } from './Keyboard';
import { MessageRow } from './ChatbotMessageBubble';
import AssistantFeedbackBox from './FeedbackBox';
import SessionFeedbackBox from './SessionFeedbackBox';
import ZoomCallBox from './ZoomCallBox';
import PrinterCallBox from './PrinterCallBox';
import LinkModal from './LinkModal';
import { cleanText, normalizeDoQueries } from './helper';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';
// import CategoryShortcutModal from './CategoryShortcutModal';

export const BACKEND_API_URL = process.env.REACT_APP_BACKEND_API_URL;

const FAQSearch = () => {
  const { library: routeParam } = useParams();
  const [searchParams] = useSearchParams();
  const navigateTo = useNavigate();
  const resolvedRoute = resolveServiceRoute(routeParam);
  const rawRouteKey = resolvedRoute.routeKey;
  const normalizedLibrary = resolvedRoute.libraryKey || 'clb';
  const isWebRoute = rawRouteKey === 'web';
  const locationPriority = isWebRoute ? '' : (LOCATION_MAP[normalizedLibrary] ?? LOCATION_MAP.clb);
  const sessionLocation = rawRouteKey || 'web';
  // Phone button: only show on physical kiosk routes, not web
  const supportCallNumber = resolvedRoute.callEnabled
    ? normalizedLibrary === 'law'
      ? '6516 2043'
      : normalizedLibrary === 'msl'
        ? '6516 2046'
        : '6516 6949'
    : null;
  // For event queries on web route, pass empty key so all-library events are returned
  const eventRouteKey = isWebRoute ? '' : rawRouteKey;

  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [results, setResults] = useState(null);
  const [error, setError] = useState('');
  const [chatInput, setChatInput] = useState('');
  const [chatLoading, setChatLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState([]);
  // const [libGuideMatches, setLibGuideMatches] = useState([]);
  const [callNumberMatches, setCallNumberMatches] = useState([]);
  const [sessionActive, setSessionActive] = useState(false);
  const [initialRAGData, setInitialRAGData] = useState(null);
  const INACTIVITY_TIMEOUT = 60 * 1000;  // 1 minute for main page reset
  const MAIN_PAGE_INACTIVITY_TIMEOUT = 60 * 1000; // 1 minute for main page reset
  const timeoutRef = useRef(null);
  const SESSION_INACTIVITY_TIMEOUT = 60 * 1000; // 1 minute for session feedback
  const mainPageTimeoutRef = useRef(null);
  const chatEndRef = useRef(null);
  const chatContainerRef = useRef(null);
  const chatInputRef = useRef(null);
  const scrollPositionRef = useRef(0);
  const preventScrollRef = useRef(false);
  // const categoryModalShownRef = useRef(false);
  // const [showSimilarAnswers, setShowSimilarAnswers] = useState(false);
  // const [showKeyboard, setShowKeyboard] = useState(false);
  // const [keyboardInput, setKeyboardInput] = useState('');
  // const keyboardRef = useRef(null);
  const [activeComponent, setActiveComponent] = useState('wayfinding');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [showChatContinueSuggestions, setShowChatContinueSuggestions]=useState(false);
  const [showInitialSuggestions, setShowInitialSuggestions] = useState(false);
  const [initialSuggestions, setInitialSuggestions] = useState([]);
  const [mapLevel, setMapLevel] = useState(null);
  const [selectedRoom, setSelectedRoom] = useState(null);
  const [selectedLibrary, setSelectedLibrary] = useState(DEFAULT_LIBRARY);
  const [initialComponentClicked,setInitialComponentClicked]=useState(null);
  const [expandedTopMatches, setExpandedTopMatches] = useState({});
  const [linkModalOpen, setLinkModalOpen] = useState(false);
  const [selectedLink, setSelectedLink] = useState({ url: '', title: '' });
  const [mapMode, setMapMode] = useState(false);
  const [showPrinterCallUI, setShowPrinterCallUI] = useState(false);
  const [callSessionId, setCallSessionId] = useState(null);
  // const [showCategoryModal, setShowCategoryModal] = useState(false);
  
  const theme = useTheme();
  // noSsr: resolve on first render so mobile never briefly renders desktop-only GIFs
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'), { noSsr: true });

  const [backendErrorOpen, setBackendErrorOpen] = useState(false);

  const isProductionSite = process.env.REACT_APP_ENV === 'production';

  const reportBackendError = (errorType) => {
    setBackendErrorOpen(true);
    if (isProductionSite) {
      axios.post(`${BACKEND_API_URL}/api/report-error`, {
        errorType,
        url: window.location.href,
        userAgent: navigator.userAgent,
        timestamp: new Date().toISOString(),
      }).catch(() => {});
    }
  };

  //feedback states
  const [activeFeedbackIndex, setActiveFeedbackIndex] = useState(null);
  const [sessionId, setSessionId] = useState(null);
  const [messageId, setMessageId] = useState(null);
  const [feedbackMode, setFeedbackMode] = useState(false);
  const [pendingFeedback, setPendingFeedback] = useState({
    messageId: null,
    feedbackType: null,
    defaultText: '',
    message_query:'',
    message_response:'',
  });

  // session feedback states
  const [showSessionFeedback, setShowSessionFeedback] = useState(false);
  const [sessionFeedbackChoice, setSessionFeedbackChoice] = useState(null); // 'happy' | 'neutral' | 'sad'
  const [sessionFeedbackComment, setSessionFeedbackComment] = useState('');
  const sessionFeedbackShowTimeoutRef = useRef(null);
  const sessionFeedbackDismissTimeoutRef = useRef(null);

  //zoom states
  const [showZoomUI, setShowZoomUI]=useState(false);
  const [zoomCallStatus, setZoomCallStatus] = useState({
    disableStartCall: false,
    disabledMessage: 'Call Assistant Coming Soon!'
  });
  const [afterHoursWindows, setAfterHoursWindows] = useState([]);

  //add to faq states
  const [showFaqQR, setShowFaqQR]=useState(false);

  // Show feedback after 20 seconds of session being active
  useEffect(() => {
    if (sessionActive) {
      sessionFeedbackShowTimeoutRef.current = setTimeout(() => {
        setShowSessionFeedback(true);
      }, SESSION_INACTIVITY_TIMEOUT); // Show after 20s
    } else {
      // Clear timer and hide feedback if session ends
      clearTimeout(sessionFeedbackShowTimeoutRef.current);
      clearTimeout(sessionFeedbackDismissTimeoutRef.current);
      setShowSessionFeedback(false);
    }

    return () => {
      clearTimeout(sessionFeedbackShowTimeoutRef.current);
      clearTimeout(sessionFeedbackDismissTimeoutRef.current);
    };
  }, [SESSION_INACTIVITY_TIMEOUT,sessionActive]);

  useEffect(() => {
    let isMounted = true;
    const loadZoomCallStatus = async () => {
      try {
        const res = await axios.get(`${BACKEND_API_URL}/api/zoom-call/status`, {
          params: { libraryKey: normalizedLibrary }
        });
        if (!isMounted) return;
        setZoomCallStatus({
          disableStartCall: Boolean(res.data?.disableStartCall),
          disabledMessage: String(res.data?.disabledMessage || 'Call Assistant Coming Soon!')
        });
      } catch (err) {
        if (!isMounted) return;
        setZoomCallStatus({
          disableStartCall: false,
          disabledMessage: 'Call Assistant Coming Soon!'
        });
      }
    };
    loadZoomCallStatus();
    return () => { isMounted = false; };
  }, [normalizedLibrary]);

  useEffect(() => {
    if (!normalizedLibrary) return;
    axios.get(`${BACKEND_API_URL}/api/after-hours-windows`, { params: { libraryKey: normalizedLibrary } })
      .then(res => setAfterHoursWindows(res.data?.windows || []))
      .catch(() => {});
  }, [normalizedLibrary]);

  useEffect(() => {
    const preventContextMenu = (e) => {
      e.preventDefault();
    };
  
    window.addEventListener("contextmenu", preventContextMenu);
  
    return () => {
      window.removeEventListener("contextmenu", preventContextMenu);
    };
  }, []);



  useEffect(() => {
    if (showSessionFeedback) {
      sessionFeedbackDismissTimeoutRef.current = setTimeout(() => {
        setShowSessionFeedback(false);
      }, 20000); // Dismiss after 20s of being visible
    }
  
    return () => {
      clearTimeout(sessionFeedbackDismissTimeoutRef.current);
    };
  }, [showSessionFeedback]);

  const handleSessionFeedback = async (type) => {
    setSessionFeedbackChoice(type);
  
    // If happy, send immediately
    if (type === 'happy') {
      try {
        await axios.post(`${BACKEND_API_URL}/api/session-feedback`, {
          feedback_type: 'session_' + type,
          session_id: sessionId,
          explanation: null
        });
        setTimeout(() => setShowSessionFeedback(false), 2000);
      } catch (err) {
        console.error("Feedback send failed", err);
      }
    }
  };
  
  // Toggle function
  const toggleTopMatch = (index) => {
    setExpandedTopMatches(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  const submitSessionFeedback = async () => {
    if (!sessionFeedbackChoice || !sessionId) return;
  
    try {
      await axios.post(`${BACKEND_API_URL}/api/session-feedback`, {
        feedback_type: 'session_' + sessionFeedbackChoice,
        session_id: sessionId,
        explanation: sessionFeedbackComment || null
      });
      alert("Session feedback submitted successfully");
      setShowSessionFeedback(false);
      setSessionFeedbackComment('');
    } catch (err) {
      console.error("Feedback send failed", err);
    }
  };

  const saveMessage = async (role, content,newSessionId,messageIndex) => {
    try {
      const messageRes= await axios.post(`${BACKEND_API_URL}/api/messages`, {
        session_id:newSessionId || sessionId,
        role,
        message_index:messageIndex,
        content,
        timestamp: new Date().toISOString()
      });
      setMessageId(messageRes.data.message_id);

    } catch (err) {
      console.error('Failed to save message:', err);
    }
  };  

  const trackStandaloneShortcutClick = async (componentClicked, label = '') => {
    try {
      const sessionRes = await axios.post(`${BACKEND_API_URL}/api/sessions`, {
        initialQuery: `[Shortcut Action] ${label || componentClicked}`,
        component_clicked: componentClicked,
        session_location: sessionLocation,
      });
      if (sessionRes?.data?.session_id) {
        setSessionId(sessionRes.data.session_id);
      }
    } catch (err) {
      console.error('Failed to track standalone shortcut click:', err);
    }
  };

  // Map query keywords → service route to redirect to when the user's query
  // clearly belongs to a different library than the current kiosk route.
  const CROSS_LIBRARY_PATTERNS = [
    { pattern: /medicine\s*science|med.*sci|msl\b/i, route: '/msl_2_service' },
    { pattern: /central\s*lib|clb\b/i,               route: '/clb_1_service' },
  ];

  const handleInitialQuery = async (queryText, componentClicked = null) => {
    let searchQuery=queryText ||query ||"";
    if (!searchQuery.trim()) return;

    // If the query explicitly mentions a different library, redirect there first.
    for (const { pattern, route } of CROSS_LIBRARY_PATTERNS) {
      if (pattern.test(searchQuery) && !window.location.pathname.startsWith(route)) {
        navigateTo(`${route}?shortcut=map`);
        return;
      }
    }

    setLoading(true);
    setError('');
    setResults(null);
    // setShowKeyboard(false);
    setInitialSuggestions([]);

    searchQuery=normalizeDoQueries(searchQuery);
    // Use the passed componentClicked parameter, fallback to state, or default to "keyboard" if neither is set
    const componentToUse = componentClicked !== null ? componentClicked : (initialComponentClicked || "keyboard");
    let newSessionId = null;
    try {
      const sessionRes = await axios.post(`${BACKEND_API_URL}/api/sessions`,{
        initialQuery:searchQuery,
        component_clicked:componentToUse,
        session_location: sessionLocation
      });
      newSessionId = sessionRes.data.session_id;
      setSessionId(newSessionId);
    } catch (err) {
      reportBackendError('Backend unavailable');
      setLoading(false);
      return;
    }
    try {
      const topMatchResFaq = await axios.post(`${BACKEND_API_URL}/api/topmatch/faq`, {
        question: searchQuery,
        locationPriority,
        routeLibraryKey: eventRouteKey
      });
      // const topMatchResLibguide = await axios.post(`${BACKEND_API_URL}/api/topmatch/libguide`, { question: searchQuery });
      const topMatches = topMatchResFaq.data.topMatches.map(match => ({
        ...match,
        question: cleanText(match.question),
        answer: cleanText(match.answer),
        keywords: cleanText(match.keywords),
        ownedBy: cleanText(match.ownedBy),
      }));

      setResults({ ...topMatchResFaq.data, topMatches });
      console.log("[FAQ initial] Top match:", topMatches[0]?.question, "| score:", topMatches[0]?.score);
      // setLibGuideMatches(topMatchResLibguide.data.topMatches || []);

      const faqContext = topMatches.slice(0, 3).map(match => 
        `Question: ${match.question}\nAnswer: ${match.answer}\nSimilarity: ${match.score}%`
      ).join('\n\n');

      const topMatchCallNumRes = await axios.post(`${BACKEND_API_URL}/api/topmatchCallnum/callnumbers`, { question: searchQuery });
      const matches = topMatchCallNumRes.data?.topMatches || [];
      const callNumberMatchesValue = matches.filter(m => m.score >= 0.03).slice(0, 5);
      setCallNumberMatches(callNumberMatchesValue);
    
      const assistantRes = await axios.post(`${BACKEND_API_URL}/api/assistant`, {
        question: searchQuery,
        locationPriority,
        routeLibraryKey: eventRouteKey,
        faqTopScore: topMatches?.[0]?.score ?? null,
        chatHistory: [],
        userInput: searchQuery,
        faqContext,
        callNumberMatches,
        isInitial: true
      });

      if (!assistantRes.data || !assistantRes.data.llm_response) {
        console.error('❌ Invalid assistant response:', assistantRes.data);
        const fallbackText = "I may not have the right information for this library-specific request yet. Please try contacting our library staff with the call button at the left side for assistance.";
        setChatHistory([
          { role: 'user', content: searchQuery },
          { role: 'assistant', content: fallbackText, topMatchAnswer: topMatches[0]?.answer || null, topMatchScore: topMatches[0]?.score, followupSuggestions: []}
        ]);
        setActiveComponent('similar_answers');
        setSessionActive(true);
        return;
      }
  
      const { llm_response, ui_component, followup_suggestions } = assistantRes.data;
      // console.log('📥 Received followup_suggestions from API (initial):', followup_suggestions, ui_component);

      const hasEventTableInResponse = /<table[\s\S]*?<\/table>/i.test(llm_response) || ui_component === 'events';
      const assistantContent = hasEventTableInResponse ? llm_response : cleanText(llm_response);

      setMapLevel(null);
      setSelectedRoom(null);

      // console.log('💾 Storing followupSuggestions in chatHistory (initial):', followup_suggestions);
      
      setChatHistory([
        { role: 'user', content: searchQuery },
        { role: 'assistant', content: assistantContent, topMatchAnswer: topMatches[0]?.answer || null, topMatchScore: topMatches[0]?.score, followupSuggestions: followup_suggestions || []}
      ]);
      await saveMessage('user', searchQuery, newSessionId, (chatHistory.length)/2);
      await saveMessage('assistant', assistantContent, newSessionId, (chatHistory.length)/2);

      setInitialRAGData({
        question: topMatches[0]?.question,
        answer: topMatches[0]?.answer,
      });  

      // "where is ..." queries show the 360 tour directory, even if the backend tagged them differently
      const isLocationQuery = /\bwhere\b/i.test(searchQuery);
      const finalUiComponent = (hasEventTableInResponse && ui_component !== 'events') ? 'events'
        : (isLocationQuery && !hasEventTableInResponse) ? 'wayfinding'
        : ui_component;
      setActiveComponent(finalUiComponent);
      setResults(prev => ({ ...prev, llm_response: assistantContent }));
      setSessionActive(true);
      
      if (newSessionId && topMatches) {
        try {
          await axios.patch(`${BACKEND_API_URL}/api/sessions/${newSessionId}`, {
            top_match_question: topMatches[0]?.question,
            top_match_question_id: topMatches[0]?.faqId,
            owner_name: topMatches[0]?.owner_name || null,
            top_matched_faq_score: topMatches[0]?.score ?? null,
            top_match_questions: topMatches.slice(0, 3).map(m => ({
              question: m.question,
              score: m.score,
              owner_name: m.owner_name || null,
            })),
          });
        } catch (err) {
          console.error('Failed to update session with top match:', err);
        }
      }
    } catch (err) {
      setError(err.response?.data?.error || 'An error occurred while searching');
      if (!err.response || err.response.status >= 500) reportBackendError('Backend unavailable');
    } finally {
      setLoading(false);
    }
  };
  
  
  const handleChatContinue = async (userQuery,messageQuery,messageResponse) => {
    // Prevent page scroll by maintaining scroll position
    const scrollY = window.scrollY;
    scrollPositionRef.current = scrollY;
    preventScrollRef.current = true;
    
    let input=userQuery || chatInput;
    if (!input.trim() || !sessionActive) {
      preventScrollRef.current = false;
      return;
    }
    
    // Restore scroll position immediately and continuously for a short period
    const restoreScroll = () => {
      if (preventScrollRef.current) {
        window.scrollTo(0, scrollPositionRef.current);
        // Continue restoring for 1 second to prevent any scroll during async operations
        setTimeout(() => {
          if (preventScrollRef.current) {
            window.scrollTo(0, scrollPositionRef.current);
          }
        }, 100);
        setTimeout(() => {
          if (preventScrollRef.current) {
            window.scrollTo(0, scrollPositionRef.current);
          }
        }, 300);
        setTimeout(() => {
          if (preventScrollRef.current) {
            window.scrollTo(0, scrollPositionRef.current);
          }
        }, 500);
      }
    };
    restoreScroll();
    
    // setShowKeyboard(false);
    setShowZoomUI(false);
    setShowFaqQR(false);
    setShowSessionFeedback(false);
    setShowChatContinueSuggestions(false);
    input=normalizeDoQueries(input);

    if (feedbackMode) {
      try { 
        // Get top_match_question and owner_name from results if available
        const topMatchQuestion = results?.topMatches?.[0]?.question || null;
        const ownerName = results?.topMatches?.[0]?.owner_name || null;
        
        await axios.post(`${BACKEND_API_URL}/api/feedback`, {
          message_id: pendingFeedback.messageId,
          feedback_type: pendingFeedback.feedbackType,
          session_id: sessionId,
          explanation: input.trim(),
          message_query:messageQuery,
          message_response:messageResponse,
          top_match_question: topMatchQuestion,
          owner_name: ownerName,
        });

        // Reset feedback mode
        setFeedbackMode(false);
        setPendingFeedback({ messageId: null, feedbackType: null, defaultText: '' });
        setChatInput('');
      } catch (err) {
        console.error("Feedback send failed", err);
      }
      return; // 🚫 Don't proceed to assistant/LLM chat
    }

    setChatLoading(true);
    const userMessage = { role: 'user', content: input };
    setChatHistory(prev => [...prev, userMessage]);
    await saveMessage('user', input, sessionId, (chatHistory.length)/2);
    setChatInput(''); // Clear input immediately
    // Scroll chat container after user message is added
    setTimeout(() => scrollChatToBottom(), 50);
    
    // Maintain scroll position after state updates - use ref value
    requestAnimationFrame(() => {
      window.scrollTo(0, scrollPositionRef.current);
    });

    try {
      const updatedHistory = [...chatHistory, userMessage];

      const topMatchResFaq = await axios.post(`${BACKEND_API_URL}/api/topmatch/faq`, {
        question: input,
        locationPriority,
        routeLibraryKey: eventRouteKey
      });
      // const topMatchResLibguide = await axios.post(`${BACKEND_API_URL}/api/topmatch/libguide`, { question: input });

      const topMatches = topMatchResFaq.data.topMatches.map(match => ({  
        ...match,
        question: cleanText(match.question),
        answer: cleanText(match.answer),
        keywords: cleanText(match.keywords),
        ownedBy: cleanText(match.ownedBy),
      }));

      setResults({ ...topMatchResFaq.data, topMatches });
      console.log("[FAQ continue] Top match:", topMatches[0]?.question, "| score:", topMatches[0]?.score);
      // setLibGuideMatches(topMatchResLibguide.data.topMatches || []);

      const faqContext = topMatches.slice(0, 3).map(match => 
        `Question: ${match.question}\nAnswer: ${match.answer}\nSimilarity: ${match.score}%`
      ).join('\n\n');      // console.log(faqContext,"faqcontext is there scores")

      const topMatchCallNumRes = await axios.post(`${BACKEND_API_URL}/api/topmatchCallnum/callnumbers`, { question: input });
      const matches = topMatchCallNumRes.data?.topMatches || [];
      const callNumberMatchesValue = matches.filter(m => m.score >= 0.03).slice(0, 5);
      setCallNumberMatches(callNumberMatchesValue);

      const assistantRes = await axios.post(`${BACKEND_API_URL}/api/assistant`, {
        question: initialRAGData?.question || '',
        locationPriority,
        routeLibraryKey: eventRouteKey,
        faqTopScore: topMatches?.[0]?.score ?? null,
        chatHistory: updatedHistory,
        userInput: input,
        faqContext,
        callNumberMatches,
        isInitial: false
      });

      const { llm_response, ui_component, followup_suggestions } = assistantRes.data;
      // console.log('📥 Received followup_suggestions from API (continue):', followup_suggestions);

      const hasEventTableInResponse = /<table[\s\S]*?<\/table>/i.test(llm_response) || ui_component === 'events';
      const assistantContent = hasEventTableInResponse ? llm_response : cleanText(llm_response);

      setMapLevel(null);
      setSelectedRoom(null);
      
      setChatHistory(prev=>[...prev, { role: 'assistant', content: assistantContent ,topMatchAnswer: topMatches[0]?.answer, topMatchScore: topMatches[0]?.score, followupSuggestions: followup_suggestions || []}]);
      // Scroll chat container after assistant response is added
      setTimeout(() => scrollChatToBottom(), 100);
      setTimeout(() => scrollChatToBottom(), 300);
      await saveMessage('assistant', assistantContent,sessionId,(chatHistory.length)/2);

      setResults(prev => ({ ...prev, llm_response: assistantContent }));

      // "where is ..." queries show the 360 tour directory, even if the backend tagged them differently
      const isLocationQuery = /\bwhere\b/i.test(input);
      const finalUiComponent = (hasEventTableInResponse && ui_component !== 'events') ? 'events'
        : (isLocationQuery && !hasEventTableInResponse) ? 'wayfinding'
        : ui_component;
      setActiveComponent(finalUiComponent);

      setChatInput('');
      
      // Restore scroll position after all state updates and disable prevention
      setTimeout(() => {
        window.scrollTo(0, scrollPositionRef.current);
        preventScrollRef.current = false;
      }, 800);
    } catch (err) {
      setError(err.response?.data?.error || 'Chat error');
      if (!err.response || err.response.status >= 500) reportBackendError('Backend unavailable');
      preventScrollRef.current = false;
    } finally {
      setChatLoading(false);
      // Final scroll restoration - ensure we restore after everything completes
      setTimeout(() => {
        window.scrollTo(0, scrollPositionRef.current);
        preventScrollRef.current = false;
      }, 1000);
    }
  };
  const getChatSuggestions = () => {
    let suggestions = [];
  
    // 1️⃣ — Prefer top match questions if available
    if (results?.topMatches?.length > 0) {
      suggestions = results.topMatches
        .slice(0, 3) // Take top 3 relevant suggestions
        .map(match => cleanText(match.question));
    } 
    // 2️⃣ — Fallback to initial top questions (if user hasn’t started chat yet)
    else if (initialSuggestions?.length > 0) {
      suggestions = initialSuggestions
        .slice(0, 3)
        .map(item => cleanText(item.top_match_question));
    } 
    // 3️⃣ — Ultimate fallback (static)
    else {
      suggestions = [
        'What are the library hours?',
        'How to book a room?',
      ];
    }
  
    // 4️⃣ — Add contextual suggestions based on chat state
    if (selectedRoom) {
      suggestions.push(`What's nearby ${selectedRoom.replace(/Level[123]\s*/, '')}?`);
    }
  
    if (chatHistory.length > 0 && chatHistory[chatHistory.length - 1].role === 'assistant') {
      suggestions.push('Tell me more about that');
    }
  
    return suggestions;
  };
  
  const handleSuggestionClick = (suggestion) => {
    setChatInput(suggestion);
    if (chatInputRef.current) {
      chatInputRef.current.focus();
    }
  };

  
  const renderLeftPanel = () => {
    // console.log(activeComponent,"activeComponent");
    const openTour = (url) => {
      const newWindow = window.open(
        url,
        '_blank',
        'width=1200,height=800,scrollbars=yes,resizable=yes'
      );
      if (!newWindow) {
        alert('Please allow pop-ups to open the 360 tour, or use this link: ' + url);
      }
    };

    switch (activeComponent) {
      case 'wayfinding': {
          const libraryDataMap = {
            clb: centralLibraryTourData,
            music: musicLibraryTourData,
            hssl: hsslTourData,
            wbsc: wbscTourData,
            law: lawLibraryTourData,
            msl: mslTourData,
          };

          const currentLibraryData = libraryDataMap[normalizedLibrary];
          if (!currentLibraryData) return <></>;

          // Try to find a specific room match from the user's query
          const lastUserQuery = [...chatHistory].reverse().find(m => m.role === 'user')?.content || '';
          const normalizedQuery = lastUserQuery.toLowerCase().replace(/[^a-z0-9\s]/g, '');
          const allTourRooms = currentLibraryData.flatMap(s => s.rooms.map(r => ({ ...r, lvl: s.lvl })));
          const matchedRoom = allTourRooms.find(room => {
            const roomNorm = room.name.toLowerCase().replace(/[^a-z0-9\s]/g, '');
            const roomWords = roomNorm.split(/\s+/).filter(w => w.length > 3);
            return roomWords.some(w => normalizedQuery.includes(w)) ||
              normalizedQuery.split(/\s+/).filter(w => w.length > 3).some(w => roomNorm.includes(w));
          });

          return (
            <Three60Container>
              <WayfindingContainer>
                <div style={{ textAlign: 'center', marginTop: '1rem', marginBottom: '0.5rem' }}>
                  <Typography variant="subtitle1" fontFamily="RobotoBlack" color={primaryColor}>
                    {locationPriority} Directory
                  </Typography>
                </div>

                {matchedRoom ? (
                  // Narrowed view: show just the matched room with a prominent open button
                  <SuggestionsWrapper style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    <LevelContainer key={matchedRoom.lvl}>
                      <ShortcutLabelInternal variant="body2">{matchedRoom.lvl}</ShortcutLabelInternal>
                      <RoomsWrapper>
                        <RoomChip
                          key={matchedRoom.name}
                          label={`Open ${matchedRoom.name} 360°`}
                          variant="filled"
                          color="primary"
                          onClick={() => openTour(matchedRoom.url)}
                          style={{ cursor: 'pointer', fontWeight: 600 }}
                        />
                      </RoomsWrapper>
                    </LevelContainer>
                    <Typography variant="caption" color="text.secondary"
                      sx={{ display: 'block', textAlign: 'center', mt: 1, mb: 0.5, cursor: 'pointer',
                            textDecoration: 'underline', fontFamily: 'RobotoRegular' }}
                      onClick={() => {}}>
                      {/* Clicking the section header shows all — handled by showing full list below */}
                    </Typography>
                    {/* Also show full directory below the match so user can explore */}
                    <ShortcutLabelInternal variant="body2" sx={{ mt: 1, opacity: 0.6 }}>Full Directory</ShortcutLabelInternal>
                    {currentLibraryData.map((section) => (
                      <LevelContainer key={section.lvl}>
                        <ShortcutLabelInternal variant="body2" sx={{ opacity: 0.7 }}>{section.lvl}</ShortcutLabelInternal>
                        <RoomsWrapper>
                          {section.rooms.map((room) => (
                            <RoomChip
                              key={room.name}
                              label={room.name}
                              variant="outlined"
                              onClick={() => openTour(room.url)}
                              style={{ cursor: 'pointer', opacity: room.name === matchedRoom.name ? 1 : 0.55 }}
                            />
                          ))}
                        </RoomsWrapper>
                      </LevelContainer>
                    ))}
                  </SuggestionsWrapper>
                ) : (
                  // Full directory when no specific room matched
                  <SuggestionsWrapper style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                    {currentLibraryData.map((section) => (
                      <LevelContainer key={section.lvl}>
                        <ShortcutLabelInternal variant="body2">{section.lvl}</ShortcutLabelInternal>
                        <RoomsWrapper>
                          {section.rooms.map((room) => (
                            <RoomChip
                              key={room.name}
                              label={room.name}
                              variant="outlined"
                              onClick={() => openTour(room.url)}
                              style={{ cursor: 'pointer' }}
                            />
                          ))}
                        </RoomsWrapper>
                      </LevelContainer>
                    ))}
                  </SuggestionsWrapper>
                )}
              </WayfindingContainer>
            </Three60Container>
          );
        }

      // falls through to default if no tour data found
      case 'similar_answers': // eslint-disable-line no-fallthrough
      default:
        return <></>;
    }
  };

  const resetSession = () => {
    setSessionActive(false);
    setQuery('');
    setChatInput('');
    setChatHistory([]);
    setResults(null);
    setInitialRAGData(null);
    // setLibGuideMatches([]);
    setCallNumberMatches([]);
    setMapLevel(null);
    setSelectedRoom(null);
    setExpandedTopMatches({});
    setMapMode(false);
    setSelectedLibrary(DEFAULT_LIBRARY);
    window.location.reload();
    // console.log("Session reset due to inactivity.",callNumberMatches);
  };

  const resetInactivityTimer = () => {
    if (timeoutRef.current) clearTimeout(timeoutRef.current);
    timeoutRef.current = setTimeout(() => {
      resetSession();
    }, INACTIVITY_TIMEOUT);
  };

  const resetMainPageInactivityTimer = () => {
    if (mainPageTimeoutRef.current) clearTimeout(mainPageTimeoutRef.current);
    // Only set timer if link modal is NOT open
    // (LinkModal handles its own inactivity when open)
    if (!linkModalOpen) {
      mainPageTimeoutRef.current = setTimeout(() => {
        resetSession();
      }, MAIN_PAGE_INACTIVITY_TIMEOUT);
    }
  };

  // Show category modal on initial page load (desktop only) - every time page refreshes
  // useEffect(() => {
  //   // Only show on initial mount when not mobile and no active session
  //   // Use ref to prevent reopening when modal state changes
  //   if (!isMobile && !sessionActive && !categoryModalShownRef.current) {
  //     setShowCategoryModal(true);
  //     categoryModalShownRef.current = true;
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []); // Empty dependency array - only run on mount

  // Handle category query selection
  // const handleCategoryQuerySelect = (queryText, categoryKey) => {
  //   setInitialComponentClicked(categoryKey);
  //   setQuery(queryText); // Update the textfield with the selected question
  //   setShowCategoryModal(false);
  //   // Small delay to ensure modal closes smoothly before query executes
  //   setTimeout(() => {
  //     handleInitialQuery(queryText);
  //   }, 100);
  // };

  useEffect(() => {
    const handleUserActivity = () => {
      // Only reset timer if modal is NOT open
      // (LinkModal handles its own inactivity when open)
      if (sessionActive && !linkModalOpen) {
        resetInactivityTimer();
      }
    };
  
    // Only add listeners if session is active and modal is closed
    if (sessionActive && !linkModalOpen) {
      window.addEventListener('click', handleUserActivity);
      window.addEventListener('keydown', handleUserActivity);
  
      resetInactivityTimer();
    }
  
    return () => {
      window.removeEventListener('click', handleUserActivity);
      window.removeEventListener('keydown', handleUserActivity);
      if (timeoutRef.current) clearTimeout(timeoutRef.current);
    };
    // eslint-disable-next-line 
  }, [sessionActive, linkModalOpen]); // Add linkModalOpen to dependencies

  // Main page 15-second inactivity timer (independent of session state)
  useEffect(() => {
    const handleMainPageActivity = () => {
      // Reset main page timer on any activity
      resetMainPageInactivityTimer();
    };

    // Add event listeners for user activity
    window.addEventListener('click', handleMainPageActivity);
    window.addEventListener('keydown', handleMainPageActivity);
    window.addEventListener('mousemove', handleMainPageActivity);
    window.addEventListener('touchstart', handleMainPageActivity);
    window.addEventListener('scroll', handleMainPageActivity);

    // Start the timer
    resetMainPageInactivityTimer();

    return () => {
      window.removeEventListener('click', handleMainPageActivity);
      window.removeEventListener('keydown', handleMainPageActivity);
      window.removeEventListener('mousemove', handleMainPageActivity);
      window.removeEventListener('touchstart', handleMainPageActivity);
      window.removeEventListener('scroll', handleMainPageActivity);
      if (mainPageTimeoutRef.current) clearTimeout(mainPageTimeoutRef.current);
    };
    // eslint-disable-next-line
  }, [linkModalOpen]); // Re-run when link modal opens/closes

  // Helper function to scroll chat container to bottom
  const scrollChatToBottom = useCallback(() => {
    if (chatContainerRef.current) {
      // Use requestAnimationFrame for smooth scrolling
      requestAnimationFrame(() => {
        if (chatContainerRef.current) {
          chatContainerRef.current.scrollTop = chatContainerRef.current.scrollHeight;
        }
      });
    }
  }, []);

  useEffect(() => {
    // Restore page scroll position if we're preventing scroll
    if (preventScrollRef.current && scrollPositionRef.current !== undefined) {
      requestAnimationFrame(() => {
        window.scrollTo(0, scrollPositionRef.current);
      });
    }
    
    // Auto-scroll chat container to bottom when chat history changes
    // Always scroll the container (not the page), regardless of preventScrollRef
    // Use multiple timeouts to ensure DOM has fully updated
    scrollChatToBottom();
    setTimeout(scrollChatToBottom, 50);
    setTimeout(scrollChatToBottom, 150);
    setTimeout(scrollChatToBottom, 300);
  }, [chatHistory, scrollChatToBottom]);

  // Scroll when feedback mode changes (when feedback boxes appear/disappear)
  useEffect(() => {
    if (feedbackMode) {
      // When feedback box appears, scroll to show it
      scrollChatToBottom();
      setTimeout(scrollChatToBottom, 100);
      setTimeout(scrollChatToBottom, 300);
    }
  }, [feedbackMode, scrollChatToBottom]);

  useEffect(() => {
    if (chatHistory.length > 0) {
      // setShowSimilarAnswers(false);
      // console.log(showSimilarAnswers,"logging")
      const lastMsg = chatHistory[chatHistory.length - 1];
      if (lastMsg.role === 'assistant') {
        setTimeout(() => {
          // setShowSimilarAnswers(true);
        }, 400);
      }
    }
        // eslint-disable-next-line 
  }, [chatHistory]);


  // const roomMatchCheck = (query, contentText = "") => {
  //   let level = extractLevelFromText(contentText) || null;
  //   console.log(level,"roomMatchCheck level")
  //   let roomPart = query.toLowerCase();
  
  //   const levelsData = {
  //     1: level1RoomsData,
  //     2: level2RoomsData,
  //     3: level3RoomsData,
  //   };
  
  //   if (level && levelsData[level]) {
  //     for (let room of levelsData[level]) {
  //       if (room.name && room.name.trim() !== "" && room.name.toLowerCase() !== "pathway" &&
  //           roomPart.includes(room.name.toLowerCase().replace(/level\d+\s*/, '').trim())) {
  //         return { found: true, level: level, roomName: room.name };
  //       }
  //     }
  //   } else {
  //     // fallback: search all levels
  //     for (let lvl in levelsData) {
  //       for (let room of levelsData[lvl]) {
  //         if (room.name && room.name.trim() !== "" && room.name.toLowerCase() !== "pathway" &&
  //             roomPart.includes(room.name.toLowerCase().replace(/level\d+\s*/, '').trim())) {
  //           return { found: true, level: parseInt(lvl), roomName: room.name };
  //         }
  //       }
  //     }
  //   }
  
  //   return { found: false, level, roomName: null };
  // };
  
  // const roomMatchCheck = (query, contentText = "") => {
  //   let level = extractLevelFromText(contentText) || null;
  
  //   // Search in BOTH query and content
  //   const searchText = `${query} ${contentText}`.toLowerCase();
  
  //   const levelsData = {
  //     1: level1RoomsData,
  //     2: level2RoomsData,
  //     3: level3RoomsData,
  //   };
  
  //   const normalize = str =>
  //     str
  //       .toLowerCase()
  //       .replace(/level\s*\d+/g, "") // remove "Level 2"
  //       .replace(/[^\w\s]/g, " ")     // remove punctuation
  //       .replace(/\s+/g, " ")        // collapse spaces
  //       .trim();
  
  //   const normalizedSearch = normalize(searchText);
  
  //   const searchLevels = level ? [level] : Object.keys(levelsData);
  
  //   for (let lvl of searchLevels) {
  //     for (let room of levelsData[lvl]) {
  //       if (!room.name || room.name.toLowerCase() === "pathway") continue;
  
  //       const normalizedRoomName = normalize(room.name);
  
  //       // fuzzy partial matching rules
  //       const match =
  //         normalizedSearch.includes(normalizedRoomName) ||     // search text contains room
  //         normalizedRoomName.includes(normalizedSearch) ||     // room contains search text
  //         normalizedRoomName.split(" ").some(w => 
  //           w.length > 3 && normalizedSearch.includes(w)       // match keywords: "collection", "printing", etc.
  //         );
  
  //       if (match) {
  //         return {
  //           found: true,
  //           level: parseInt(lvl),
  //           roomName: room.name,
  //         };
  //       }
  //     }
  //   }
  
  //   return { found: false, level, roomName: null };
  // };
  
  const fetchInitialSuggestions = async () => {
    try {
      const res = await axios.get(`${BACKEND_API_URL}/api/sessions/top-questions`); // Your endpoint should return [{ question, count }]
      const suggestions = res.data.slice(0, 4).map(item => ({
        top_match_question: item.top_match_question
      }));
      setInitialSuggestions(suggestions);
      setShowInitialSuggestions(true);
    } catch (err) {
      console.error('Failed to fetch initial suggestions', err);
    }
  };
  
  const handleTextFieldFocus = (field) => {
    // setKeyboardInput(field === 'query' ? query : chatInput);

    if (field === 'query') {
      fetchInitialSuggestions(); // Fetch suggestions on initial search field focus
    }

    if (field === 'chat' && chatInputRef.current) {
      chatInputRef.current.focus();
    }
  };

  const handleShortcutClick = (prefix) => {
    setQuery(prefix);
    setShowSuggestions(true);
  };

  const trackStartZoomCallClick = async () => {
    try {
      const res = await axios.post(`${BACKEND_API_URL}/api/call-button-click/start`, {
        session_id: callSessionId || null,
        session_location: sessionLocation,
      });
      if (!callSessionId && res?.data?.session_id) {
        setCallSessionId(res.data.session_id);
      }
    } catch (err) {
      console.error('Failed to track Start Zoom Call with Staff click:', err);
    }
  };

  return (
    <Container>
      <Snackbar
        open={backendErrorOpen}
        onClose={() => setBackendErrorOpen(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        sx={{ top: { xs: 16, sm: 24 } }}
      >
        <Alert
          onClose={() => setBackendErrorOpen(false)}
          severity="warning"
          variant="filled"
          sx={{ width: '100%', fontFamily: 'Roboto, sans-serif', fontSize: '15px' }}
        >
          We're updating the system. Some features may be temporarily unavailable. Please try again after 5:00 PM.
        </Alert>
      </Snackbar>


      {/* Home button — top-left on mobile, left-center on desktop */}
      <SearchEndContainer>
        {(sessionActive && results) && (
          <EndButton
            onClick={() => {
              resetSession();
            }}
          >
            <MdOutlineHome size={20} />
          </EndButton>
        )}
      </SearchEndContainer>

      {/* Mobile-only call button — bottom-left corner */}
      {isMobile && supportCallNumber && (
        <Fab
          size="medium"
          onClick={async () => {
            setShowZoomUI(true);
            trackStandaloneShortcutClick(`call_button_${sessionLocation}`, 'Call Icon Button Click');
            try {
              const res = await axios.post(`${BACKEND_API_URL}/api/call-button-click`, {
                session_location: sessionLocation
              });
              if (res.data.session_id) setCallSessionId(res.data.session_id);
            } catch (err) {
              console.error('Failed to track call button click:', err);
            }
          }}
          style={{
            position: 'fixed',
            bottom: '1rem',
            left: '1rem',
            backgroundColor: '#E30B5D',
            color: 'white',
            zIndex: 1200,
          }}
          aria-label="Call for Help"
        >
          <MdPhone size={20} />
        </Fab>
      )}

      <LogoImage src="/nuslibrarieslogo.png" alt="nuslogo" onClick={() => resetSession()}
        style={{ opacity: 1 }} />

      <Content>
        {!isMobile && mapMode && (
          <ResultsBox style={{ width: '100%', maxWidth: '100%', padding: 0, margin: 0 }}>
            <WayfindingContainer style={{ width: '100%', height: '100vh' }}>
              <LevelSwitchContainer>
                {getAvailableLevels(selectedLibrary).map((level) => (
                  <LevelMapButtons 
                    key={level} 
                    onClick={() => setMapLevel(level)}
                    active={mapLevel === level}
                  >
                    L{level}
                  </LevelMapButtons>
                ))}
                <LevelMapButtons 
                  onClick={() => {
                    setMapMode(false);
                    setMapLevel(null);
                  }}
                  style={{ marginLeft: 'auto' }}
                >
                  Exit
                </LevelMapButtons>
              </LevelSwitchContainer>

              <MapRenderer
                library={selectedLibrary}
                level={mapLevel}
                selectedRoomQuery={selectedRoom}
                fullWidth={true}
              />
            </WayfindingContainer>
          </ResultsBox>
        )}

        {(!sessionActive || !results) && !mapMode && (
          <>
            <GifContainer>
              {/* GifContainer is hidden on mobile, but a hidden <img> still downloads, so skip it entirely */}
              {!isMobile && (
                <RandomGifPlayer
                  gifList={["/libbie/smiling.gif"]}
                  displayDuration={3000}
                />
              )}
              {supportCallNumber && (
              <Fab
                variant="extended"
                size="large"
                onClick={async () => {
                  setShowZoomUI(true);
                  trackStandaloneShortcutClick(`call_button_${sessionLocation}`, 'Call Icon Button Click');
                  try {
                    const res = await axios.post(`${BACKEND_API_URL}/api/call-button-click`, {
                      session_location: sessionLocation
                    });
                    if (res.data.session_id) setCallSessionId(res.data.session_id);
                  } catch (err) {
                    console.error('Failed to track call button click:', err);
                  }
                }}
                style={{
                  backgroundColor: '#E30B5D',
                  color: 'white',
                  textTransform: 'none',
                  fontWeight: 'bold',
                  fontSize: '1rem',
                  gap: '8px',
                  width: '100%',
                  marginTop: '-40px',
                }}
                aria-label="Call for Help"
              >
                <MdPhone size={22} />
                Call for Help
              </Fab>
              )}
            </GifContainer>
            <SearchContainer>
              <BackgroundBlur>
                <GradientTitle showSuggestions={showSuggestions} variant="h3" fontFamily="RobotoRegular">
                  I'm here to help you find your way around the library!
                </GradientTitle>

                <SearchPaperInitial elevation={3}>
                  <SearchBoxInitial>
                    <CustomTextField
                      fullWidth
                      value={query}
                      onChange={(e) => setQuery(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          handleInitialQuery(null, 'keyboard');
                        }
                      }}
                      onFocus={() => handleTextFieldFocus('query')}
                      variant="outlined"
                      disabled={loading}
                      placeholder="Ask anything..."
                    />
                    {/* <KeyboardIcon onClick={() => setShowKeyboard(!showKeyboard)}>
                      <MdKeyboard color={primaryColor} size={24} />
                    </KeyboardIcon> */}
                    <VoiceButton
                      onTranscript={(text) => {
                        setQuery(text);
                        handleInitialQuery(text, 'keyboard');
                      }}
                    />
                    <SearchButton
                      onClick={() => {
                        handleInitialQuery(null, 'keyboard');
                      }}
                      disabled={loading || !query.trim()}
                    >
                      {loading ? <CircularProgress size={20} color="inherit" /> : <MdEast size={20} />}
                    </SearchButton>
                  </SearchBoxInitial>

                  {showInitialSuggestions && initialSuggestions.length > 0 && (
                    <SuggestionsDropdown elevation={3}>
                      {initialSuggestions.map((item, index) => (
                        <SuggestionItem
                          key={index}
                          onClick={async () => {
                            try {
                              setQuery(item.top_match_question);
                              setShowSuggestions(false);
                              await handleInitialQuery(item.top_match_question, 'keyboard');
                            } catch (err) {
                              console.error("Error fetching suggestion:", err);
                            }
                          }}
                        >
                          {item.top_match_question}
                        </SuggestionItem>
                      ))}
                    </SuggestionsDropdown>
                  )}
                  {/* {showKeyboard && (
                    <RenderKeyboard
                      keyboardRef={keyboardRef}
                      input={keyboardInput}
                      onChange={onChangeKeyboard}
                      onKeyPress={onKeyPress}
                    />
                  )} */}
                </SearchPaperInitial>

              <ShortcutPanel
                setActiveComponent={setActiveComponent}
                query={query}
                setQuery={setQuery}
                locationPriority={locationPriority}
                routeLibraryKey={normalizedLibrary}
                serviceRouteKey={rawRouteKey}
                initialShortcut={searchParams.get('shortcut')}
                setShowInitialSuggestions={setShowInitialSuggestions}
                showSuggestions={showSuggestions}
                handleShortcutClick={handleShortcutClick}
                handleInitialQuery={handleInitialQuery}
                setInitialComponentClicked={setInitialComponentClicked}
                onMapModeClick={(level)=>{
                  if (isMobile) return;
                  setMapMode(true);
                  setActiveComponent('wayfinding');
                  setMapLevel(level);}}
                mapLevel={mapLevel}
                onPrinterIssueClick={() => setShowPrinterCallUI(true)}
                onStandaloneShortcutClick={trackStandaloneShortcutClick}
              />
              {/* Disclaimer inside the blur box on mobile so it stays in-viewport */}
              {isMobile && (
                <DisclaimerText variant="caption" fontFamily="RobotoRegular"
                  sx={{ position: 'static', transform: 'none', left: 'auto !important',
                        zIndex: 1, mt: 2.5, px: 1, textAlign: 'center',
                        fontSize: 'clamp(0.65rem, 2.5vw, 0.8rem) !important' }}>
                  Disclaimer: This digital front desk is a work in progress, and accuracy of results may vary as the AI learns and adapts to new queries. If you require further assistance, please contact askalib@nus.edu.sg.
                </DisclaimerText>
              )}
            </BackgroundBlur>
            </SearchContainer>

            {/* Desktop-only absolute disclaimer */}
            {!isMobile && (
              <DisclaimerText variant="caption" fontFamily="RobotoRegular">
                Disclaimer: This digital front desk is a work in progress, and accuracy of results may vary as the AI learns and adapts to new queries. If you require further assistance, please contact askalib@nus.edu.sg.
              </DisclaimerText>
            )}
          </>
        )}

        {error && <ErrorAlert severity="error">{error}</ErrorAlert>}

        {(results && sessionActive && !mapMode) && (
          <ResultsBox>
            {isMobile ? null : renderLeftPanel()}
            <Chatbot>
              <ResponseCardChatbot>
                <ChatbotMessageBubbleContainer ref={chatContainerRef}>
                  {chatHistory.map((msg, index) => (
                    <React.Fragment key={index}>
                      <MessageRow
                        query={query}
                        handleChatContinue={handleChatContinue}
                        setChatInput={setChatInput}
                        BACKEND_API_URL={BACKEND_API_URL}
                        msg={msg}
                        index={index}
                        isMobile={isMobile}
                        activeComponent={activeComponent}
                        expandedTopMatches={expandedTopMatches}
                        toggleTopMatch={toggleTopMatch}
                        activeFeedbackIndex={activeFeedbackIndex}
                        setPendingFeedback={setPendingFeedback}
                        setActiveFeedbackIndex={setActiveFeedbackIndex}
                        setFeedbackMode={setFeedbackMode}
                        chatHistory={chatHistory}
                        sessionId={sessionId}
                        messageId={messageId}
                        setLinkModalOpen={setLinkModalOpen}
                        setSelectedLink={setSelectedLink}
                        chatContainerRef={chatContainerRef}
                        results={results}
                      />

                      {feedbackMode && msg.role === 'assistant' && messageId === pendingFeedback.messageId && index === activeFeedbackIndex && (
                        <AssistantFeedbackBox
                          isMobile={isMobile}
                          showFaqQR={showFaqQR}
                          setChatInput={setChatInput}
                          setPendingFeedback={setPendingFeedback}
                          setFeedbackMode={setFeedbackMode}
                          setActiveFeedbackIndex={setActiveFeedbackIndex}
                        />
                      )}

                      {(!(showZoomUI || showFaqQR) && index === chatHistory.length - 1 && showSessionFeedback) && (
                        <SessionFeedbackBox
                          sessionFeedbackComment={sessionFeedbackComment}
                          setSessionFeedbackComment={setSessionFeedbackComment}
                          submitSessionFeedback={submitSessionFeedback}
                          open={showSessionFeedback}
                          onClose={() => setShowSessionFeedback(false)}
                          sessionFeedbackChoice={sessionFeedbackChoice}
                          handleSessionFeedback={handleSessionFeedback}
                          primaryColor={primaryColor}
                        />
                      )}
                      <div ref={chatEndRef}></div>
                    </React.Fragment>
                  ))}

                </ChatbotMessageBubbleContainer>

                <SearchBox>
                  {!feedbackMode && showChatContinueSuggestions && sessionActive && (
                    <SuggestionsContainer>
                      {getChatSuggestions().map((suggestion, index) => (
                        <SuggestionChip
                          key={index}
                          label={suggestion}
                          onClick={(e) => {
                            e.preventDefault();
                            e.stopPropagation();
                            handleSuggestionClick(suggestion);
                            handleChatContinue(suggestion, chatHistory[activeFeedbackIndex - 1]?.content, chatHistory[activeFeedbackIndex]?.content);
                          }}
                          variant="outlined"
                          size="small"
                        />
                      ))}
                    </SuggestionsContainer>
                  )}

                  <TextFieldContainer>
                    <CustomTextField
                      feedbackMode={feedbackMode}
                      fullWidth
                      inputRef={chatInputRef}
                      value={chatInput}
                      onChange={(e) => setChatInput(e.target.value)}
                      onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                          e.preventDefault();
                          e.stopPropagation();
                          const scrollY = window.scrollY;
                          handleChatContinue(e.target.value, chatHistory[activeFeedbackIndex - 1]?.content, chatHistory[activeFeedbackIndex]?.content);
                          // Restore scroll position
                          requestAnimationFrame(() => {
                            window.scrollTo(0, scrollY);
                          });
                        }
                      }}
                      onFocus={(e) => {
                        e.preventDefault();
                        handleTextFieldFocus('chat');
                        setShowChatContinueSuggestions(true);
                        // Prevent scroll on focus
                        const scrollY = window.scrollY;
                        requestAnimationFrame(() => {
                          window.scrollTo(0, scrollY);
                        });
                      }}
                      placeholder={feedbackMode ? "Type your feedback here..." : "Ask a question..."}
                      disabled={chatLoading}
                    />
                    {/* <KeyboardIcon onClick={() => setShowKeyboard(!showKeyboard)}>
                      <MdKeyboard color={primaryColor} size={24} />
                    </KeyboardIcon> */}
                    <VoiceButton
                      onTranscript={(text) => {
                        setChatInput(text);
                        // Prevent scroll on voice input
                        setTimeout(() => {
                          handleChatContinue(text, chatHistory[activeFeedbackIndex - 1]?.content, chatHistory[activeFeedbackIndex]?.content);
                        }, 100);
                      }}
                    />
                    <SearchButton
                      feedbackMode={feedbackMode}
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleChatContinue(chatInput, chatHistory[activeFeedbackIndex - 1]?.content, chatHistory[activeFeedbackIndex]?.content);
                      }}
                      disabled={chatLoading || !chatInput.trim()}
                      startIcon={chatLoading ? <CircularProgress size={20} /> : ""}
                      type="button"
                    >
                      <Typography fontSize="12px">{chatLoading ? '' : 'Send'}</Typography>
                    </SearchButton>
                  </TextFieldContainer>
                  {/* {showKeyboard && (
                    <RenderKeyboard
                      keyboardRef={keyboardRef}
                      input={keyboardInput}
                      onChange={onChangeKeyboard}
                      onKeyPress={onKeyPress}
                    />
                  )} */}
                </SearchBox>
              </ResponseCardChatbot>
            </Chatbot>
          </ResultsBox>
        )}
      </Content>
      <ZoomCallBox
        open={showZoomUI}
        onClose={() => setShowZoomUI(false)}
        disableStartCall={zoomCallStatus.disableStartCall}
        disabledMessage={zoomCallStatus.disabledMessage}
        supportCallNumber={supportCallNumber}
        showPhonePrompt={!!supportCallNumber}
        showZoom={false /* zoom call feature disabled */}
        afterHoursMode={(() => {
          if (!afterHoursWindows.length) return false;
          const now = new Date();
          const sgOffset = 8 * 60;
          const utcMin = now.getUTCHours() * 60 + now.getUTCMinutes();
          const sgMin = (utcMin + sgOffset) % (24 * 60);
          const sgDow = (now.getUTCDay() + (utcMin + sgOffset >= 24 * 60 ? 1 : 0)) % 7;
          const sgDate = new Date(now.getTime() + sgOffset * 60000).toISOString().slice(0, 10);
          const toMin = t => { const [h, m] = String(t || '').split(':').map(Number); return h * 60 + m; };
          return afterHoursWindows.some(w => {
            if (w.specific_date && String(w.specific_date).slice(0, 10) !== sgDate) return false;
            if (!w.specific_date && w.day_of_week !== null && Number(w.day_of_week) !== sgDow) return false;
            if (w.all_day) return true;
            const start = toMin(w.start_time);
            const end = toMin(w.end_time);
            return end <= start ? sgMin >= start || sgMin < end : sgMin >= start && sgMin < end;
          });
        })()}
        onStartCallClick={trackStartZoomCallClick}
      />
      <PrinterCallBox
        open={showPrinterCallUI}
        onClose={() => setShowPrinterCallUI(false)}
      />


      <LinkModal
        open={linkModalOpen}
        onClose={() => {
          setLinkModalOpen(false);
          setSelectedLink({ url: '', title: '' });
        }}
        url={selectedLink.url}
        title={selectedLink.title}
      />

      {/* <CategoryShortcutModal
        open={showCategoryModal}
        onClose={() => setShowCategoryModal(false)}
        onSelectQuery={handleCategoryQuerySelect}
      /> */}

    </Container>
  );
};

export default FAQSearch;